/**
 * Deploy / environment label for UI gates and exports.
 * Set ``VITE_DEPLOY_STAGE`` explicitly, else infer from ``VITE_API_URL``.
 */
export function inferDeployStageLabel(): string {
  const explicit = import.meta.env.VITE_DEPLOY_STAGE as string | undefined;
  if (explicit?.trim()) {
    return explicit.trim();
  }

  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8001';
  try {
    const host = new URL(apiUrl).hostname.toLowerCase();
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'local';
    }
    const rogercalls = host.match(/^portal-api-([a-z0-9-]+)\.rogercalls\.com$/);
    if (rogercalls?.[1]) {
      return rogercalls[1];
    }
    if (host === 'portal-api.rogerhealthcare.com') {
      return 'prod';
    }
    return host;
  } catch {
    return 'unknown';
  }
}
